import { Fragment } from 'preact'

export const VoieDeRecours = (props) => {
  return (
    <Fragment>
      <h2 class="mt-2 mb-1">Voies de recours</h2>
      <p>
        Vous avez signalé au responsable du site internet un défaut d'accessibilité qui vous empêche d'accéder à un contenu ou à un des services du portail et vous n'avez pas
        obtenu de réponse satisfaisante, dans ce cas&nbsp;:{' '}
      </p>
      <ul class="list">
        <li>
          Écrire un message au <a href="https://formulaire.defenseurdesdroits.fr/formulaire_saisine/" target="_blank" title="Défenseur des droits (nouvelle fenêtre)">Défenseur des droits</a>.
        </li>
        <li>
          Contacter le <a href="https://www.defenseurdesdroits.fr/carte-des-delegues" target="_blank" title="délégué du Défenseur des droits dans votre région (nouvelle fenêtre)">délégué du Défenseur des droits dans votre région</a>.
        </li>
        <li>
          Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre)
          <br />
          Défenseur des droits
          <br />
          Libre réponse 71120
          <br />
          75342 Paris CEDEX 07
        </li>
      </ul>
    </Fragment>
  )
}
